export default (clientHttp, apiVersion) => ({
  getTaxCertificatePdf(houseId, year) {
    return clientHttp.get(
      `${apiVersion}/user/houses/${houseId}/owner_tax_certificates.pdf?year=${year}`,
    )
  },
})
